// extracted by mini-css-extract-plugin
export default {"signinButton":"SigninButton_signinButton__2RjQI"};